import React, { useRef, useEffect, forwardRef } from 'react';
import dayjs from 'dayjs';

const dayNamesPl = ["Pon", "Wt", "Śr", "Czw", "Pt", "Sob", "Nie"];

const MobileWeekSelector = forwardRef(({
                                           currentWeekStart,
                                           selectedDay,
                                           onDaySelect,
                                           onPrevWeek,
                                           onNextWeek,
                                           swipeOffset = 0,
                                           isSwipeAnimating = false,
                                           events = []
                                       }, ref) => {
    const scrollContainerRef = useRef(null);
    const selectedDayRef = useRef(null);

    // Auto-scroll to selected day
    useEffect(() => {
        if (selectedDayRef.current && scrollContainerRef.current) {
            const container = scrollContainerRef.current;
            const selectedElement = selectedDayRef.current;
            const containerWidth = container.offsetWidth;
            const selectedLeft = selectedElement.offsetLeft;
            const selectedWidth = selectedElement.offsetWidth;

            // Center the selected day
            const scrollLeft = selectedLeft - (containerWidth / 2) + (selectedWidth / 2);
            container.scrollTo({ left: scrollLeft, behavior: 'smooth' });
        }
    }, [selectedDay]);

    // Generate days of the week
    const daysOfWeek = Array.from({ length: 7 }, (_, i) =>
        currentWeekStart.add(i, "day")
    );

    // Check if day has events
    const dayHasEvents = (dayDate) => {
        return events.some(event =>
            dayjs(event.startTime).isSame(dayDate, 'day')
        );
    };

    return (
        <div className="mobile-week-overview">
            <div
                ref={ref || scrollContainerRef}
                className={`mobile-days-grid ${isSwipeAnimating ? 'animating' : ''}`}
                style={{
                    transform: `translateX(${swipeOffset}px)`,
                    transition: isSwipeAnimating ? 'transform 0.2s ease-out' : 'none',
                    touchAction: 'pan-y'
                }}
            >
                {daysOfWeek.map((dayDate) => {
                    const isSelected = selectedDay?.isSame(dayDate, 'day');
                    const isToday = dayDate.isSame(dayjs(), 'day');
                    const hasEvents = dayHasEvents(dayDate);

                    return (
                        <div
                            key={dayDate.format('YYYY-MM-DD')}
                            ref={isSelected ? selectedDayRef : null}
                            className={`mobile-day-item ${isSelected ? 'selected' : ''} ${isToday ? 'today' : ''}`}
                            onClick={() => onDaySelect(dayDate)}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    onDaySelect(dayDate);
                                }
                            }}
                            aria-label={`${isSelected ? 'Wybrany: ' : ''}${dayDate.format('dddd, DD MMMM')}`}
                            aria-current={isToday ? 'date' : undefined}
                        >
                            <div className="mobile-day-name">
                                {dayNamesPl[dayDate.isoWeekday() - 1]}
                            </div>
                            <div className="mobile-day-date">
                                {dayDate.format('DD')}
                            </div>
                            <div
                                className={`mobile-day-indicator ${hasEvents ? 'has-events' : ''}`}
                                aria-label={hasEvents ? 'Ma wydarzenia' : 'Brak wydarzeń'}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
});

// MobileWeekSelector.displayName = 'MobileWeekSelector';

export default MobileWeekSelector;